import jwt_decode from "jwt-decode";

const getUserFromToken = (token) => {
    if (!token) return;
    const decodedToken = jwt_decode(token);
    const user = decodedToken?.user;
    return user;
}
export default getUserFromToken;